export enum MenuType {
    Group = 'group',
    Collapse = 'collapse',
    Item = 'item',
}

export enum MenuGroup {
    Dashboard = 'dashboard',
    Cases = 'cases',
    Settings = 'settings',
}

export enum MenuItem {
    Admin = 'admin',
    AdminCustomer = 'adminCustomer',
    DashCustomer = 'dashCustomer',
    CaseAdd = 'caseAdd',
    CaseEdit = 'caseEdit',
    Reports = 'reports',
    Settings = 'settings',
    Contact = 'contact',
    Faq = 'faq',
}
